const Preloader = () => {
  return (
    <div className="preloader">
      <p>Загрузка...</p>
    </div>
  );
};

export default Preloader;
